import { UpdateUserInputDTOSchema } from '@doutorsim/shared/users'
import { z } from 'zod'

import { createUserSchema } from './create-user'

export const editUserSchema = createUserSchema.extend({
  id: z.uuid(),
  name: UpdateUserInputDTOSchema.shape.name,
  companyId: z.uuid(),
})

export type EditUserSchema = z.infer<typeof editUserSchema>
